import type { TFunction } from 'i18next';

/**
 * Yükleme göstergesinin bağlama göre mesajları.
 *
 * Bekleme uzadıkça sırayla gösteriliyor: ilk mesaj ne olduğunu söyler, sonrakiler
 * ekranın takılmadığını gösterir. Tek yerde toplanmasının sebebi, aynı bekleme türünün
 * her ekranda aynı dili konuşması — "Yükleniyor…" ile "Bekleyin…" arasında gidip gelmek
 * ekranı gelişigüzel gösteriyordu.
 */
export type LoaderKind =
  | 'app'
  | 'screen'
  | 'data'
  | 'detail'
  | 'report'
  | 'dashboard'
  | 'designer'
  | 'form'
  | 'file';

export function loaderMessages(t: TFunction, kind: LoaderKind): string[] {
  const steps = t(`loader.${kind}`, { returnObjects: true });
  // Çeviri eksikse anahtar metin olarak döner; ham anahtar göstermektense sessiz kal.
  return Array.isArray(steps) ? (steps as string[]) : [];
}
